<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div v-if="isEdit" class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold d-none d-md-block">Chỉnh sửa đào tạo</p>
                <p class="text-xl font-semibold d-block d-md-none">Quay lại</p>
            </div>
            <p v-else class="text-xl font-semibold">Quản lý đào tạo</p>
            <div>
                <div class="flex gap-1" v-if="isEdit">
                    <button @click="getEntry" class="admin-refresh-btn">
                        <i class='bx bx-refresh my-auto' ></i><p>Đặt lại</p>
                    </button>
                    <button @click="saveEntry" class="admin-save-btn">
                        <i class='bx bxs-save my-auto' ></i><p>Lưu</p>
                    </button>
                </div>
                <button @click="isEdit = true" v-else class="admin-edit-btn">
                    <i class='bx bxs-edit-alt text-black my-auto' ></i><p>Chỉnh sửa</p>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-7 row">
                <b-form-group class="col-12 mb-3 pr-0 pr-md-3">
                    <!-- <label class="mb-1 text-lg d-flex align-items-center">
                        Bản quyền
                    </label>
                    <b-input :disabled="!isEdit" v-model="entry" type="text" placeholder="Nhập tên bản quyền..." /> -->
                    Boo đang làm... hehe
                </b-form-group>
            </div>
            <div class="col-12 col-md-5 mt-2">
                <div v-for="(item, index) in entry.trainingMethod" :key="index">
                    <div class="p-1 mb-2 flex justify-between gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle="'position-' + index">
                        <h3 class="text-lg font-semibold mb-0">Phương thức đào tạo {{ index+1 }}</h3>
                        <h4 v-show="isEdit" @click.prevent="deleteMethod(index)" class="text-lg font-semibold mb-0 hover:text-yellow-300 px-1"><i class='bx bxs-trash'></i></h4>
                    </div>
                    <b-collapse :visible="index == 0 ? true : false" class="px-1 py-2" :id="'position-' + index" role="tabpanel" accordion="my-accordion">
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Tiêu đề
                            </label>
                            <b-input :disabled="!isEdit" v-model="item.title" type="text" placeholder="Nhập tiêu đề..." />
                        </b-form-group>
                        <b-form-group>
                            <label class="mb-1 text-lg d-flex align-items-center">
                                Mô tả
                            </label>
                            <b-textarea rows="3" :disabled="!isEdit" v-model="item.description" type="text" placeholder="Nhập tiêu đề..." />
                        </b-form-group>
                    </b-collapse>
                </div>
                <vue-page-transition name="fade">
                    <div v-show="isEdit" @click="addNewMethod" role="tab" v-b-toggle="'position-' + (entry.trainingMethod.length-1)" class="p-1 gap-2 px-3 py-1 border-[1px] border-slate-600 text-slate-600 rounded-xl cursor-pointer hover:bg-slate-600 hover:text-white">
                        <h3 class="text-lg text-center font-semibold">+ Thêm cơ sở mới</h3>
                    </div>
                </vue-page-transition>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'manage-config',
    data() {
        return {
            webConfig: {},
            entry: {},
            isEdit: false,
            isSave: false,
        }
    },
    methods: {
        ...mapActions('webConfig', ['GetWebConfigList', 'UpdateWebConfig']),
        async getEntry() {
            let response = await this.GetWebConfigList()
            this.webConfig = response.data
            this.entry = this.webConfig.manageTraining
        },
        goBack() {
            this.getEntry()
            this.isEdit = false
        },
        addNewMethod() {
            this.entry.trainingMethod.push({title: null, description: null})
        },
        deleteMethod(index) {
            this.entry.trainingMethod.splice(index,1);
        },
        additionalValidator() {
            for (let index in this.entry.trainingMethod) {
                if (!this.entry.trainingMethod[index].title) {
                    let message = 'Tiêu đề PT tuyển sinh thứ ' + (Number(index)+1) + '<br>không được để trống'
                    this.$swal.fire(message, '', 'error')
                    return false
                }
                if (!this.entry.trainingMethod[index].description) {
                    let message = 'Mô tả PT tuyển sinh thứ ' + (Number(index)+1) + '<br>không được để trống'
                    this.$swal.fire(message, '', 'error')
                    return false
                }
            }
            return true
        },
        saveEntry() {
            let validate = {
                // credit: 'Tên bản quyền',
                // email: 'Địa chỉ email',
                // facebook: 'Đường dẫn facebook',
                // youtube: 'Đường dẫn youtube',
            };
            if (!this.$validator(this.entry, validate)) return
            if (!this.additionalValidator()) return
            this.$swal.fire({
            title: 'Sửa cấu hình trang web?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sửa!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let response = await this.UpdateWebConfig(this.webConfig)
                    if (response.code == 200) {
                        this.getEntry()
                        this.isEdit = false
                        this.$swal.fire('Cập nhật thành công', '', 'success')
                    } else {
                        this.$swal.fire('Cập nhật không thành công', '', 'error')
                    }
                }
            })
        },
    },
    created(){
        this.getEntry()
    },
}
</script>